import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "antd";
import { SSRContextProvider } from "./context/SSRContext";
import useSSR from "../SSR/hooks/useSSR";
import { SSR_NO_DATA } from "src/Modules/Flights/constants/JourneyDetails";
import StepButtons from "../../components/StepButtons/StepButtons";
import useStepFlow from "src/Modules/Flights/hooks/useStepFlow";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import SSRWeb from "./layouts/SSR.web";
import SSRMob from "./layouts/SSR.mob";
import SSRSkeletonWeb from "./layouts/SSR.skeleton.web";
import SSRSkeletonMob from "./layouts/SSR.skeleton.mob";

const SSRComponent = withConditionalComponent(SSRWeb, SSRMob);
const SSRSkeletonComponent = withConditionalComponent(SSRSkeletonWeb, SSRSkeletonMob);

export default function SSR() {
  const { t } = useTranslation();
  const ssr = useSSR();
  const {  goToNextStep } = useStepFlow();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  const stepButtons = (
    <StepButtons
      nextLabel={t("Flights.details.steps.proceedToPayment")}
      onNext={() => goToNextStep()}
    />
  );

  if (ssr.isFetching) return <SSRSkeletonComponent trigger={isLargeScreen} props={{ stepButtons }} />;

  if (!ssr.SSROptions.length)
    return (
      <>
        <SSR_NO_DATA />
        {stepButtons}
      </>
    );

  return (
    <SSRContextProvider value={ssr}>
      <SSRComponent trigger={isLargeScreen} props={{ stepButtons }} />
    </SSRContextProvider>
  );
}
